import dayjs from 'dayjs';
import { Dayjs, extend, ConfigType } from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

extend(utc);
extend(timezone);

export class DateUtils {
  /**
   * Dashboard / API `days_of_week`: 1 = Monday … 7 = Sunday.
   * `dayjs().day()` is 0 = Sunday … 6 = Saturday. Adding 1 shifts every day
   * (Friday becomes 6) and falsely flags a weekday catalog as closed.
   */
  static isoDayOfWeek(date?: ConfigType): number {
    const day = dayjs(date).day();
    return day === 0 ? 7 : day;
  }

  static isLessThanFromNow(date: Date, ms: number): boolean {
    const msAgo = new Date(Date.now() - ms);
    return date > msAgo;
  }

  static dayjsInMarketplaceTimezone(date?: ConfigType): Dayjs {
    return dayjs.tz(dayjs(dayjs(date).format()).utc());
  }

  static formatLocalizedDate(date: ConfigType, format: string): string {
    const formatted = this.dayjsInMarketplaceTimezone(date).format(format);
    return formatted.charAt(0).toUpperCase() + formatted.slice(1);
  }
}
